import { branch, compose, renderNothing, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import EventEmitter from 'events';
import { closeConfirmModal, openConfirmModal } from '../actions';
import ConfirmModal from '../components/ConfirmModal';
import {
  getClassName,
  getConfirmButtonText,
  getMessage,
  getNegativeButtonText,
  getOpened,
  getShowConfirmButton,
  getShowNegativeButton,
  getTitle,
  getType,
} from '../selectors';
import {
  CONFIRM_MODAL_CONFIRM,
  CONFIRM_MODAL_NEGATIVE,
  OPEN_CONFIRM_MODAL,
  CLOSE_CONFIRM_MODAL,
} from '../constants';

const ConfirmModalContainer = compose(
  connect(
    state => ({
      title: getTitle(state),
      message: getMessage(state),
      opened: getOpened(state),
      type: getType(state),
      confirmButtonText: getConfirmButtonText(state),
      negativeButtonText: getNegativeButtonText(state),
      showConfirmButton: getShowConfirmButton(state),
      showNegativeButton: getShowNegativeButton(state),
      className: getClassName(state),
    }),
    { closeConfirmModal, openConfirmModal }
  ),
  withHandlers({
    closeAndDispose: props => () => {
      EventEmitter.prototype.removeAllListeners(CONFIRM_MODAL_CONFIRM);
      EventEmitter.prototype.removeAllListeners(CONFIRM_MODAL_NEGATIVE);
      EventEmitter.prototype.removeAllListeners(CLOSE_CONFIRM_MODAL);
      props.closeConfirmModal();
    },
  }),
  withHandlers({
    close: props => () => {
      EventEmitter.prototype.emit(CLOSE_CONFIRM_MODAL);
      props.closeAndDispose();
    },
  }),
  withHandlers({
    confirm: props => () => {
      EventEmitter.prototype.emit(CONFIRM_MODAL_CONFIRM);
      props.closeAndDispose();
    },
    negative: props => () => {
      EventEmitter.prototype.emit(CONFIRM_MODAL_NEGATIVE);
      props.closeAndDispose();
    },
  }),
  lifecycle({
    componentDidMount() {
      EventEmitter.prototype.on(OPEN_CONFIRM_MODAL, this.props.openConfirmModal);
    },
    componentWillUnmount() {
      EventEmitter.prototype.removeListener(OPEN_CONFIRM_MODAL, this.props.openConfirmModal);
    },
  }),
  branch(
    props => !props.opened,
    renderNothing,
  ),
)(ConfirmModal);

export default ConfirmModalContainer;
